































import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMDatePicker from '@/web/components/common/HMDatePicker.vue';
import QuizSubmissionsTable from './QuizSubmissionsTable.vue';

export default Vue.extend({
  name: 'QuizSubmissions',
  components: { HMDatePicker, QuizSubmissionsTable },
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
    }),
    searchQuery() {
      return {
        quizId: this.quiz.id,
        q: this.search,
        status: this.status,
        startDate: this.selectedDateRange?.startDate,
        endDate: this.selectedDateRange?.endDate,
      };
    },
    allStatuses() {
      return [
        {
          label: this.$t('QUIZZES.STATUS.ALL_STATUSES'),
          value: '',
        },
        {
          label: this.$t('QUIZZES.STATUS.PASSED'),
          value: 'passed',
        },
        {
          label: this.$t('QUIZZES.STATUS.FAILED'),
          value: 'failed',
        },
        {
          label: this.$t('QUIZZES.STATUS.REVIEW'),
          value: 'not_completed',
        },
      ];
    },
  },
  data() {
    return {
      quizStats: null,
      search: '',
      status: '',
      selectedDateRange: {},
    };
  },
  methods: {},
});
